import classNames from 'classnames';
import type { JSX } from 'react';
import { type DropdownIndicatorProps, components } from 'react-select';

export const DropdownIndicator = <T,>(
  props: DropdownIndicatorProps<T>,
): JSX.Element => (
  <components.DropdownIndicator {...props}>
    <i
      className={classNames(
        'fa',
        props.isFocused ? 'fa-chevron-up' : 'fa-chevron-down',
        'text-lgu-base text-gray-900',
      )}
    />
  </components.DropdownIndicator>
);
